<div class="main-container">
  <div class="inner-container overflow-y px-3 pb-3 text-break">
    <div class="dm-container d-flex flex-column align-items-center page-deleted">
      <div class="page-deleted-title">{{ "DELETED_SHIPMENT_TITLE" | translate }}</div>
      <!--  <div class="page-deleted-body">{{ "DELETED_SHIPMENT_BODY" | translate }}</div> -->
    </div>
  </div>
</div>
